/* SUPRAFEEL · ficha de producto (sections/sfw-pdp-*.liquid)
   - accordions ([data-sfw-acc]): panel + active lists, max-height transition, first item open
   - popups ([data-sfw-modal-open] → .sfw-pdx-overlay): scroll lock, Escape, click outside, focus return
   - claim cards ([data-sfw-claims]): the clicked card grows and shows its claim
   Event delegation on document, so sections re-rendered by the theme editor keep working. */
(function () {
  if (window.__sfwPdp) return;
  window.__sfwPdp = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function panelOf(item) {
    return item.querySelector(':scope > .sfw-pd-acc-panel, :scope > .sfw-pdx-active-panel');
  }

  function toggleItem(item, head) {
    var panel = panelOf(item);
    if (!panel) return;
    var open = item.classList.contains('is-open');
    if (open) {
      // from "none" (initially open) or a px value → px → 0 so the close animates
      panel.style.maxHeight = Math.ceil(panel.scrollHeight) + 'px';
      if (!reduce) panel.getBoundingClientRect();
      panel.style.maxHeight = '0px';
      item.classList.remove('is-open');
      head.setAttribute('aria-expanded', 'false');
    } else {
      panel.style.maxHeight = Math.ceil(panel.scrollHeight) + 'px';
      item.classList.add('is-open');
      head.setAttribute('aria-expanded', 'true');
    }
  }

  /* ---------- popups ---------- */
  var current = null;
  var lastFocus = null;
  var prevOverflow = '';

  function openModal(id, trigger) {
    var ov = document.getElementById(id);
    if (!ov) return;
    if (ov.parentNode !== document.body) document.body.appendChild(ov); // escape transformed ancestors
    lastFocus = trigger || document.activeElement;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    if (window.__lenis && window.__lenis.stop) window.__lenis.stop();
    ov.hidden = false;
    current = ov;
    var close = ov.querySelector('[data-sfw-modal-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function closeModal() {
    if (!current) return;
    current.hidden = true;
    current = null;
    document.body.style.overflow = prevOverflow;
    if (window.__lenis && window.__lenis.start) window.__lenis.start();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var opener = t.closest('[data-sfw-modal-open]');
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-sfw-modal-open'), opener);
      return;
    }
    if (current) {
      if (t.closest('[data-sfw-modal-close]') || !t.closest('.sfw-pdx-modal')) {
        closeModal();
        return;
      }
    }

    var head = t.closest('.sfw-pd-acc-head, .sfw-pdx-active-head');
    if (head && head.closest('[data-sfw-acc]')) {
      var item = head.closest('.sfw-pd-acc, .sfw-pdx-active');
      if (item) toggleItem(item, head);
      return;
    }

    var claim = t.closest('[data-sfw-claims] .sfw-pdx-claim');
    if (claim) {
      var wrap = claim.closest('[data-sfw-claims]');
      wrap.querySelectorAll('.sfw-pdx-claim').forEach(function (c) {
        var on = c === claim;
        c.classList.toggle('is-open', on);
        c.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) closeModal();
  });
})();

/* Gallery slider ([data-sfw-gallery]): scroll-snap track + arrows + thumbnails, delegated so
   sections re-rendered by the theme editor keep working. */
(function () {
  if (window.__sfwPdpGallery) return;
  window.__sfwPdpGallery = true;

  function indexOf(track) {
    return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  }

  function goTo(gallery, i) {
    var track = gallery.querySelector('[data-sfw-track]');
    var n = track.querySelectorAll('[data-sfw-slide]').length;
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: i * track.clientWidth });
  }

  // fade the strip's right edge while more thumbnails are hidden past it
  function thumbEdge(strip) {
    var more = strip.scrollLeft + strip.clientWidth < strip.scrollWidth - 2;
    strip.classList.toggle('has-more', more);
    if (!strip._sfwEdge) { strip._sfwEdge = true; strip.addEventListener('scroll', function () { thumbEdge(strip); }, { passive: true }); window.addEventListener('resize', function () { thumbEdge(strip); }); }
  }
  document.querySelectorAll('[data-sfw-gallery] .sfw-pd-thumbs').forEach(function (s) { thumbEdge(s); });
  function sync(gallery) {
    var track = gallery.querySelector('[data-sfw-track]');
    var slides = track.querySelectorAll('[data-sfw-slide]');
    var i = indexOf(track);
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    gallery.querySelectorAll('[data-sfw-thumb]').forEach(function (t) {
      var on = +t.getAttribute('data-sfw-thumb') === i;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      // keep the active thumbnail in view when the strip scrolls (many photos, mobile)
      var strip = t.parentElement;
      if (on && strip && strip.scrollWidth > strip.clientWidth + 1) {
        strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      }
    });
    var strip0 = gallery.querySelector('.sfw-pd-thumbs');
    if (strip0) thumbEdge(strip0);
    var prev = gallery.querySelector('[data-sfw-prev]');
    var next = gallery.querySelector('[data-sfw-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= slides.length - 1;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var gallery = t.closest('[data-sfw-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-sfw-track]');
    var thumb = t.closest('[data-sfw-thumb]');
    if (thumb) goTo(gallery, +thumb.getAttribute('data-sfw-thumb'));
    else if (t.closest('[data-sfw-prev]')) goTo(gallery, indexOf(track) - 1);
    else if (t.closest('[data-sfw-next]')) goTo(gallery, indexOf(track) + 1);
  });

  document.addEventListener('keydown', function (e) {
    var track = e.target instanceof Element && e.target.closest('[data-sfw-track]');
    if (!track || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
    e.preventDefault();
    goTo(track.closest('[data-sfw-gallery]'), indexOf(track) + (e.key === 'ArrowRight' ? 1 : -1));
  });

  var raf = 0;
  document.addEventListener('scroll', function (e) {
    var track = e.target instanceof Element && e.target.matches('[data-sfw-track]') ? e.target : null;
    if (!track) return;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { sync(track.closest('[data-sfw-gallery]')); });
  }, true);
})();
